import { render } from "./Inicio.vue?vue&type=template&id=38c25c98"
import script from "./Inicio.vue?vue&type=script&lang=js"
export * from "./Inicio.vue?vue&type=script&lang=js"

import "./Inicio.vue?vue&type=style&index=0&id=38c25c98&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__